<template>
  <div>
    <CRow><CCol sm="12" md="12" style="text-align: center;"><br /><br /><h1><b>PANEL DE CONTROL</b></h1><br /><br /></CCol></CRow>
    <CRow>
      <CCol sm="6" md="3"></CCol>
      <CCol sm="6" md="2">
        <a href="/#/panel/customers" style="text-decoration: none;">
            <CWidgetProgressIcon
                header="Clientes"
                color="gradient-success"
                inverse
                text="Info & Contratos"
            >
                <CIcon name="cil-folder-open" height="36"/>
            </CWidgetProgressIcon>
        </a>
      </CCol>
      <CCol sm="6" md="2">
        <a href="/#/panel/visits" style="text-decoration: none;">
          <CWidgetProgressIcon
            header="Visitas"
            color="gradient-info"
            text="Programación & Monitoreo"
            inverse
          >
            <CIcon name="cil-alarm" height="36"/>
          </CWidgetProgressIcon>
        </a>
      </CCol>
      <CCol sm="6" md="2">
        <a href="/#/panel/reports" style="text-decoration: none;">
          <CWidgetProgressIcon
            header="Reportes"
            text="Resultados & Estadísticas"
            color="gradient-warning"
            inverse
          >
            <CIcon name="cil-chart" height="36"/>
          </CWidgetProgressIcon>
        </a>
      </CCol>
      <CCol sm="6" md="3"></CCol>
      </CRow>
      <CRow><CCol sm="6" md="3"><br /><br /></CCol></CRow>
      <CRow>
      <CCol sm="6" md="3"></CCol>
      <CCol sm="6" md="2">
        <a href="/#/panel/employees" style="text-decoration: none;">
          <CWidgetProgressIcon
            header="Colaboradores"
            text="RR.HH & Nómina"
            color="gradient-primary"
            inverse
          >
            <CIcon name="cil-people" height="36"/>

          </CWidgetProgressIcon>
        </a>
      </CCol>
      <CCol sm="6" md="2">
        <a href="/#/panel/kams" style="text-decoration: none;">
          <CWidgetProgressIcon
            header="Kams"
            text="Soporte & Supervisión"
            color="gradient-danger"
            inverse
          >
            <CIcon name="cil-speedometer" height="36"/>
          </CWidgetProgressIcon>
        </a>
      </CCol>
      <CCol sm="6" md="2">
        <a href="/#/panel/security" style="text-decoration: none;">
          <CWidgetProgressIcon
            header="Seguridad"
            text="Usuarios & Permisos"
            color="gradient-dark"
            inverse
          >
            <CIcon name="cil-https" height="36"/>
          </CWidgetProgressIcon>
        </a>
      </CCol>
      <CCol sm="6" md="3"></CCol>
    </CRow>
  </div>
</template>
<script>

import store from '../../store'
import ws from '../../services/graphs';
import DonoutSemaforoGraph from './graphs/DonoutSemaforo.vue';
import GaugeSemaforoGraph from './graphs/GaugeSemaforo.vue';
import GaugePercentSemaforoGraph from './graphs/GaugePercentSemaforo.vue';
import GraphsMenu from './GraphsMenu.vue';

export default {
  name: 'Home',
  components: {
    DonoutSemaforoGraph,
    GaugeSemaforoGraph,
    GaugePercentSemaforoGraph,
    GraphsMenu
  },
  data () {
    return {
      code: 'general',
      collaborators: [],
      fields: [
          {key: 'position', label: ''},
          {key: 'name', label: 'Colaborador'},
          {key: 'total', label: 'Promedio'},
        ],
      
      customerSelect: "",
      customersOptions: [],
      monthSelect: "202409",
      monthsOptions: [],
      dataGraphs: [],
      graphs_gauge: 0,
      semaforo: 0,
      graphs_percent:0,
      graphs_donout:[{code: '',service : "",total : "0",}],
      metrics:{
        total : "0",
        finished : "0",
        finished_percent: "0",
        left : "0",
        left_percent : "0"
      }
    }
  },
  mounted: async function() {
    this.loading();

    this.code = await this.$route.params.code;

    let is_administrator = localStorage.getItem("is_administrator");

    this.loaded();
  },
  methods: {
    showToast(type, message){
        store.commit('toast', {color: type, message: message});
    },
    color (value) {
      let $color
      if (value <= 25) {
        $color = 'info'
      } else if (value > 25 && value <= 50) {
        $color = 'danger'
      } else if (value > 50 && value <= 75) {
        $color = 'warning'
      } else if (value > 75 && value <= 100) {
        $color = 'success'
      }
      return $color
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>

<style>
.warning{
 background-color: #F9B115;
}
.success{
  background-color: #1B9E3E;
}
.danger{
  background-color: #E55353
}
.other{
  background-color: #6b7785
}
.card.success{
  color:black !important;
  font-weight: bold !important;
}
.card-header-actions select{
  font-size: 12px;
}
.card-header{
  font-size: 20px;
  padding: 10px 15px 10px 20px;

}
.card-body{
  padding-bottom: 25px;
}
.progress{
  display: none;
}
</style>
